import * as Yup from 'yup';
export const TechnicalEvaluationAnswerValidations = Yup.object().shape({
      // overview: Yup.string().max(255).required('Please fill the technical overview.'),
      // categories: Yup.array().of(Yup.object().shape({
      //       sections: Yup.array().of(Yup.object().shape({
      //             answer: Yup.string().required()
      //           }))
      //     }))
});